import { render, staticRenderFns } from "./tab-button.component.vue?vue&type=template&id=38c362ee&scoped=true&"
import script from "./tab-button.component.vue?vue&type=script&lang=ts&"
export * from "./tab-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./tab-button.component.vue?vue&type=style&index=0&id=38c362ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c362ee",
  null
  
)

export default component.exports